<template>
  <svg
    :width="size"
    :height="size * (52.6672 / 55.3336)"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.43478 15.3559H11.9783C12.3087 15.4155 12.6446 15.2747 12.8264 14.9985C13.0136 14.7223 13.0136 14.3649 12.8264 14.0887C12.6391 13.8126 12.3087 13.6718 11.9783 13.7313H9.5C8.51971 12.7404 7.18696 12.1555 5.78261 12.1068H3.30435L0 13.7313M12.8594 14.9227L16.5217 13.7259C17.4414 13.4606 18.4272 13.7855 19 14.5382C8.89971 19.504 12.1655 19.4769 3.30435 16.5689L0 18.5996M14.5121 4.33445C15.4496 5.1724 16.5279 6.59902 16.8743 8.51487C17.1321 9.94032 15.7016 11.0206 14.1029 11.0206H10.2062C8.60751 11.0206 7.17705 9.94032 7.43478 8.51487C7.78118 6.59902 8.85955 5.1724 9.797 4.33445C10.0698 4.09061 10.2062 3.96869 10.5075 3.85586C10.8088 3.74302 11.0678 3.74302 11.5857 3.74302H12.7234C13.2414 3.74302 13.5003 3.74302 13.8016 3.85586C14.1029 3.96869 14.2393 4.09061 14.5121 4.33445ZM11.7309 3.74302H12.5783C13.1813 3.74302 13.4828 3.74302 13.7162 3.64068C13.9495 3.53834 14.061 3.35718 14.284 2.99487C14.607 2.35571 14.7686 2.03614 14.6839 1.69659C14.6659 1.62438 14.6271 1.52676 14.5905 1.46187C14.4185 1.15673 14.1375 1.05441 13.5755 0.849783C12.6244 0.503512 11.7794 0.516936 10.7543 0.888599C10.2154 1.08396 9.94601 1.18163 9.77315 1.44294C9.70842 1.54079 9.65125 1.68413 9.63094 1.79953C9.57671 2.10766 9.72619 2.4034 10.0251 2.99487C10.2481 3.35718 10.3596 3.53834 10.593 3.64068C10.8263 3.74302 11.1278 3.74302 11.7309 3.74302Z"
      :stroke="color"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number;
    color?: string;
  }>(),
  {
    size: 64,
    color: "currentColor",
  },
);
</script>
